import React from 'react';
import styles from '../../styles/rca/rca.module.scss';

const RCABuyerInfo = () => {

    return (
        <div className={`text-left mb-5`} >
            <h2 className={`${styles.boxCategory} ${styles.title}`}>
                Cum cumpar RCA pe Conso?
            </h2>
            <p className={styles.info}>
                Cumperi asigurarea RCA in cateva minute. Primesti pe loc polita si poti circula legal chiar de mâine.
            </p>
            <ol className={`list-group ${styles.list}`}>
                <li className="list-group-item d-flex align-items-center">
                    <span className={`badge rounded-pill mr-3 ${styles.blueBadge}`}>1</span>
                    <div className={styles.info}>
                        Completezi formularul cu informațiile din talon
                    </div>
                </li>
                <li className="list-group-item d-flex align-items-center">
                    <span className={`badge rounded-pill mr-3 ${styles.blueBadge}`}>2</span>
                    <div className={styles.info}>
                        Compari toate ofertele din piață și alegi asigurarea RCA potrivită nevoilor tale
                    </div>
                </li>
                <li className="list-group-item d-flex align-items-center">
                    <span className={`badge rounded-pill mr-3 ${styles.blueBadge}`}>3</span>
                    <div className={styles.info}>
                        Cumperi online și primești polița pe loc. Poți circula chiar de mâine legal, cu polița electronică.
                    </div>
                </li>
            
            </ol>
        </div>
    )
}

export default RCABuyerInfo;